import Link from "next/link";
import { ButtonHTMLAttributes, ReactNode } from "react";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
	children: ReactNode;
	href?: string;
	variant?: "primary" | "secondary";
	className?: string;
}

export default function Button({
	children,
	href,
	variant = "primary",
	className = "",
	...props
}: ButtonProps) {
	const baseStyles =
		"px-8 py-3 rounded-full font-semibold transition-all duration-300 inline-block text-center transform hover:scale-105 active:scale-95 relative overflow-hidden";

	const variantStyles = {
		primary:
			"bg-primary text-white border-2 border-primary before:absolute before:inset-0 before:bg-white before:translate-y-full hover:before:translate-y-0 before:transition-transform before:duration-300 before:ease-out hover:text-primary",
		secondary:
			"bg-white text-primary border-2 border-primary before:absolute before:inset-0 before:bg-primary before:translate-y-full hover:before:translate-y-0 before:transition-transform before:duration-300 before:ease-out hover:text-white",
	};

	const combinedClassName = `${baseStyles} ${variantStyles[variant]} ${className}`;

	if (href) {
		return (
			<Link href={href} className={combinedClassName}>
				<span className="relative z-10">{children}</span>
			</Link>
		);
	}

	return (
		<button className={combinedClassName} {...props}>
			<span className="relative z-10">{children}</span>
		</button>
	);
}
